import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=204e148b&"
import script from "./Messenger.vue?vue&type=script&lang=js&"
export * from "./Messenger.vue?vue&type=script&lang=js&"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=204e148b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports